import React, { useState, useMemo } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Paper,
  Chip,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Avatar,
  Tabs,
  Tab,
  useTheme,
  useMediaQuery,
  alpha,
} from "@mui/material";
import {
  People,
  DirectionsCar,
  LocationOn,
  Email,
  Phone,
  TrendingUp,
  Warning,
  CheckCircle,
  Cancel,
  Cake,
  Male,
  Female,
  AttachMoney,
  FamilyRestroom,
  Interests,
  CalendarToday,
  Lightbulb,
} from "@mui/icons-material";
import {
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  AreaChart,
  Area,
  RadarChart,
  Radar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
} from "recharts";

const mockContacts = [
  {
    id: "1",
    name: "Rohan Sharma",
    email: "rohan.sharma@tech-solutions.com",
    phone: "+91-9876543210",
    vehicleType: "Car",
    age: 35,
    location: "Mumbai",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Maruti Suzuki",
    lastPurchaseYear: 2022,
    interests: ["eco-friendly", "performance"],
    familySize: 4,
    occupation: "Software Engineer",
    nextPurchaseIntent: true,
    satisfactionScore: 8,
  },
  {
    id: "2",
    name: "Priya Singh",
    email: "priya.singh@bizcorp.in",
    phone: null,
    vehicleType: "Truck",
    age: 42,
    location: "Delhi",
    consent: false,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Tata Motors",
    lastPurchaseYear: 2020,
    interests: ["luxury", "off-road"],
    familySize: 3,
    occupation: "Business Owner",
    nextPurchaseIntent: false,
    satisfactionScore: 7,
  },
  {
    id: "3",
    name: "Amit Kumar",
    email: "amit.kumar@motozone.net",
    phone: "+91-8765432109",
    vehicleType: "Motorcycle",
    age: 28,
    location: "Bangalore",
    consent: true,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Royal Enfield",
    lastPurchaseYear: 2023,
    interests: ["adventure", "performance"],
    familySize: 2,
    occupation: "Delivery Executive",
    nextPurchaseIntent: true,
    satisfactionScore: 9,
  },
  {
    id: "4",
    name: "Deepa Patel",
    email: "deepa.patel@autoexpress.co.in",
    phone: "+91-7654321098",
    vehicleType: "SUV",
    age: 50,
    location: "Chennai",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Mahindra",
    lastPurchaseYear: 2019,
    interests: ["family", "luxury"],
    familySize: 5,
    occupation: "Manager",
    nextPurchaseIntent: true,
    satisfactionScore: 6,
  },
  {
    id: "5",
    name: "Kunal Gupta",
    email: "kunal.gupta@wheelsindia.org",
    phone: null,
    vehicleType: "Car",
    age: 31,
    location: "Hyderabad",
    consent: false,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Hyundai",
    lastPurchaseYear: 2021,
    interests: ["eco-friendly", "tech"],
    familySize: 3,
    occupation: "Analyst",
    nextPurchaseIntent: false,
    satisfactionScore: 8,
  },
  {
    id: "6",
    name: "Sneha Rao",
    email: "sneha.rao@transportnet.com",
    phone: "+91-6543210987",
    vehicleType: "Van",
    age: 45,
    location: "Kolkata",
    consent: true,
    gender: "Female",
    incomeBracket: "Medium",
    vehicleBrand: "Force Motors",
    lastPurchaseYear: 2022,
    interests: ["family", "utility"],
    familySize: 6,
    occupation: "Teacher",
    nextPurchaseIntent: true,
    satisfactionScore: 7,
  },
  {
    id: "7",
    name: "Rahul Reddy",
    email: "rahul.reddy@gearheads.store",
    phone: "+91-5432109876",
    vehicleType: "Motorcycle",
    age: 22,
    location: "Pune",
    consent: true,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Bajaj Auto",
    lastPurchaseYear: 2024,
    interests: ["adventure", "speed"],
    familySize: 1,
    occupation: "Student",
    nextPurchaseIntent: false,
    satisfactionScore: 9,
  },
  {
    id: "8",
    name: "Pooja Joshi",
    email: "pooja.joshi@truckingindia.biz",
    phone: null,
    vehicleType: "Truck",
    age: 38,
    location: "Ahmedabad",
    consent: false,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Ashok Leyland",
    lastPurchaseYear: 2018,
    interests: ["utility", "durability"],
    familySize: 4,
    occupation: "Logistics Coordinator",
    nextPurchaseIntent: true,
    satisfactionScore: 5,
  },
  {
    id: "9",
    name: "Sagar Mehta",
    email: "sagar.mehta@carworld.online",
    phone: "+91-4321098765",
    vehicleType: "Car",
    age: 29,
    location: "Jaipur",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Renault",
    lastPurchaseYear: 2023,
    interests: ["tech", "performance"],
    familySize: 2,
    occupation: "Designer",
    nextPurchaseIntent: true,
    satisfactionScore: 8,
  },
  {
    id: "10",
    name: "Nisha Devi",
    email: "nisha.devi@luxurymotors.co",
    phone: "+91-3210987654",
    vehicleType: "SUV",
    age: 55,
    location: "Lucknow",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Kia",
    lastPurchaseYear: 2020,
    interests: ["luxury", "comfort"],
    familySize: 3,
    occupation: "Doctor",
    nextPurchaseIntent: false,
    satisfactionScore: 9,
  },
  {
    id: "11",
    name: "Arjun Verma",
    email: "arjun.verma@driveforward.net.in",
    phone: null,
    vehicleType: "Car",
    age: 27,
    location: "Surat",
    consent: false,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Volkswagen",
    lastPurchaseYear: 2021,
    interests: ["eco-friendly", "adventure"],
    familySize: 2,
    occupation: "Sales Executive",
    nextPurchaseIntent: true,
    satisfactionScore: 7,
  },
  {
    id: "12",
    name: "Divya Sharma",
    email: "divya.sharma@logisticshub.in",
    phone: "+91-2109876543",
    vehicleType: "Truck",
    age: 48,
    location: "Kanpur",
    consent: true,
    gender: "Female",
    incomeBracket: "Medium",
    vehicleBrand: "SML Isuzu",
    lastPurchaseYear: 2019,
    interests: ["durability", "utility"],
    familySize: 5,
    occupation: "Entrepreneur",
    nextPurchaseIntent: true,
    satisfactionScore: 6,
  },
  {
    id: "13",
    name: "Aditya Singh",
    email: "aditya.singh@bikelovers.com",
    phone: "+91-1098765432",
    vehicleType: "Motorcycle",
    age: 33,
    location: "Nagpur",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "TVS Motor Company",
    lastPurchaseYear: 2022,
    interests: ["speed", "performance"],
    familySize: 3,
    occupation: "Engineer",
    nextPurchaseIntent: false,
    satisfactionScore: 8,
  },
  {
    id: "14",
    name: "Meena Reddy",
    email: "meena.reddy@travelvans.org.in",
    phone: null,
    vehicleType: "Van",
    age: 40,
    location: "Indore",
    consent: false,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Eicher Motors",
    lastPurchaseYear: 2023,
    interests: ["family", "comfort"],
    familySize: 4,
    occupation: "Consultant",
    nextPurchaseIntent: true,
    satisfactionScore: 9,
  },
  {
    id: "15",
    name: "Vikram Gupta",
    email: "vikram.gupta@jeepadventures.net",
    phone: "+91-9876543211",
    vehicleType: "SUV",
    age: 26,
    location: "Thane",
    consent: true,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Jeep",
    lastPurchaseYear: 2024,
    interests: ["off-road", "adventure"],
    familySize: 1,
    occupation: "Freelancer",
    nextPurchaseIntent: true,
    satisfactionScore: 7,
  },
  {
    id: "16",
    name: "Kiran Patel",
    email: "kiran.patel@automart.com",
    phone: "+91-8765432110",
    vehicleType: "Car",
    age: 52,
    location: "Bhopal",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Toyota",
    lastPurchaseYear: 2017,
    interests: ["reliability", "eco-friendly"],
    familySize: 4,
    occupation: "Executive",
    nextPurchaseIntent: false,
    satisfactionScore: 8,
  },
  {
    id: "17",
    name: "Anjali Desai",
    email: "anjali.desai@trucksales.in",
    phone: null,
    vehicleType: "Truck",
    age: 30,
    location: "Visakhapatnam",
    consent: false,
    gender: "Female",
    incomeBracket: "Medium",
    vehicleBrand: "Mahindra",
    lastPurchaseYear: 2022,
    interests: ["durability", "utility"],
    familySize: 3,
    occupation: "Operations Manager",
    nextPurchaseIntent: true,
    satisfactionScore: 6,
  },
  {
    id: "18",
    name: "Sanjay Kumar",
    email: "sanjay.kumar@riderszone.online",
    phone: "+91-7654321109",
    vehicleType: "Motorcycle",
    age: 44,
    location: "Pimpri-Chinchwad",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Suzuki Motorcycle India",
    lastPurchaseYear: 2021,
    interests: ["performance", "speed"],
    familySize: 4,
    occupation: "Technician",
    nextPurchaseIntent: true,
    satisfactionScore: 9,
  },
  {
    id: "19",
    name: "Priya Verma",
    email: "priya.verma@carhub.co",
    phone: "+91-6543211098",
    vehicleType: "Car",
    age: 37,
    location: "Vadodara",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Honda",
    lastPurchaseYear: 2020,
    interests: ["comfort", "tech"],
    familySize: 5,
    occupation: "HR Professional",
    nextPurchaseIntent: false,
    satisfactionScore: 8,
  },
  {
    id: "20",
    name: "Rajesh Sharma",
    email: "rajesh.sharma@suvmarket.biz.in",
    phone: null,
    vehicleType: "SUV",
    age: 41,
    location: "Ghaziabad",
    consent: false,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Skoda",
    lastPurchaseYear: 2019,
    interests: ["family", "off-road"],
    familySize: 3,
    occupation: "Clerk",
    nextPurchaseIntent: true,
    satisfactionScore: 5,
  },
  {
    id: "21",
    name: "Deepak Rao",
    email: "deepak.rao@vanlifers.net",
    phone: "+91-5432109877",
    vehicleType: "Van",
    age: 23,
    location: "Ludhiana",
    consent: true,
    gender: "Male",
    incomeBracket: "Low",
    vehicleBrand: "Chrysler",
    lastPurchaseYear: 2023,
    interests: ["adventure", "utility"],
    familySize: 2,
    occupation: "Artist",
    nextPurchaseIntent: true,
    satisfactionScore: 7,
  },
  {
    id: "22",
    name: "Shruti Gupta",
    email: "shruti.gupta@driveeasy.com",
    phone: "+91-4321098766",
    vehicleType: "Car",
    age: 39,
    location: "Agra",
    consent: true,
    gender: "Female",
    incomeBracket: "Medium",
    vehicleBrand: "Maruti Suzuki",
    lastPurchaseYear: 2024,
    interests: ["eco-friendly", "comfort"],
    familySize: 4,
    occupation: "Marketing Specialist",
    nextPurchaseIntent: false,
    satisfactionScore: 9,
  },
  {
    id: "23",
    name: "Gopal Singh",
    email: "gopal.singh@haulingco.in",
    phone: null,
    vehicleType: "Truck",
    age: 46,
    location: "Nashik",
    consent: false,
    gender: "Male",
    incomeBracket: "High",
    vehicleBrand: "Tata Motors",
    lastPurchaseYear: 2018,
    interests: ["durability", "luxury"],
    familySize: 5,
    occupation: "CEO",
    nextPurchaseIntent: true,
    satisfactionScore: 8,
  },
  {
    id: "24",
    name: "Pankaj Kumar",
    email: "pankaj.kumar@bikelegends.org",
    phone: "+91-3210987655",
    vehicleType: "Motorcycle",
    age: 32,
    location: "Faridabad",
    consent: true,
    gender: "Male",
    incomeBracket: "Medium",
    vehicleBrand: "Hero MotoCorp",
    lastPurchaseYear: 2022,
    interests: ["speed", "adventure"],
    familySize: 3,
    occupation: "Journalist",
    nextPurchaseIntent: true,
    satisfactionScore: 7,
  },
  {
    id: "25",
    name: "Smita Desai",
    email: "smita.desai@exploreauto.online",
    phone: "+91-2109876544",
    vehicleType: "SUV",
    age: 51,
    location: "Meerut",
    consent: true,
    gender: "Female",
    incomeBracket: "High",
    vehicleBrand: "Hyundai",
    lastPurchaseYear: 2021,
    interests: ["family", "tech"],
    familySize: 4,
    occupation: "Lawyer",
    nextPurchaseIntent: false,
    satisfactionScore: 9,
  },
];

const COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#8884D8",
  "#82ca9d",
  "#A4DE6C",
  "#D0ED57",
  "#FFC658",
  "#FF8042",
];

const ageRanges = [
  { name: "18-25", min: 18, max: 25 },
  { name: "26-35", min: 26, max: 35 },
  { name: "36-45", min: 36, max: 45 },
  { name: "46-55", min: 46, max: 55 },
  { name: "56+", min: 56, max: 100 },
];

const purchaseRecencyRanges = [
  { name: "<1 Year", min: 2025, max: Infinity }, // Assuming current year 2025
  { name: "1-3 Years", min: 2022, max: 2024 },
  { name: "4-6 Years", min: 2019, max: 2021 },
  { name: "7+ Years", min: -Infinity, max: 2018 },
];

const MarketingContactsAnalysis1 = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [tabValue, setTabValue] = useState(0);

  // Calculate analytics with added properties
  const analytics = useMemo(() => {
    const totalContacts = mockContacts.length;
    const currentYear = 2025; // Based on current date

    // Consent analysis
    const withConsent = mockContacts.filter((c) => c.consent).length;
    const withoutConsent = totalContacts - withConsent;

    // Vehicle type analysis
    const vehicleTypes = mockContacts.reduce((acc, contact) => {
      acc[contact.vehicleType] = (acc[contact.vehicleType] || 0) + 1;
      return acc;
    }, {});

    // Location analysis
    const locations = mockContacts.reduce((acc, contact) => {
      acc[contact.location] = (acc[contact.location] || 0) + 1;
      return acc;
    }, {});

    // Age analysis
    const ageData = ageRanges.map((range) => {
      const count = mockContacts.filter(
        (c) => c.age >= range.min && c.age <= range.max
      ).length;
      return {
        name: range.name,
        value: count,
        percentage: (count / totalContacts) * 100,
      };
    });

    // Gender analysis
    const genderData = mockContacts.reduce((acc, contact) => {
      acc[contact.gender] = (acc[contact.gender] || 0) + 1;
      return acc;
    }, {});

    // Email and Phone availability
    const emailAvailable = mockContacts.filter((c) => c.email).length;
    const phoneAvailable = mockContacts.filter((c) => c.phone).length;

    // Top locations
    const topLocations = Object.entries(locations)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 5);

    // Vehicle type data for charts
    const vehicleTypeData = Object.entries(vehicleTypes).map(
      ([name, value]) => ({ name, value })
    );

    // Income bracket analysis
    const incomeData = ["Low", "Medium", "High"].map((bracket) => {
      const count = mockContacts.filter(
        (c) => c.incomeBracket === bracket
      ).length;
      return {
        name: bracket,
        value: count,
        percentage: (count / totalContacts) * 100,
      };
    });

    // Brand analysis
    const brands = mockContacts.reduce((acc, contact) => {
      acc[contact.vehicleBrand] = (acc[contact.vehicleBrand] || 0) + 1;
      return acc;
    }, {});
    const brandData = Object.entries(brands)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 8); // Top 8 brands

    // Interests analysis (top interests)
    const interests = mockContacts.reduce((acc, contact) => {
      contact.interests.forEach((interest) => {
        acc[interest] = (acc[interest] || 0) + 1;
      });
      return acc;
    }, {});
    const interestData = Object.entries(interests)
      .map(([name, value]) => ({ name, value }))
      .sort((a, b) => b.value - a.value)
      .slice(0, 6);

    // Family size distribution
    const familySizeRanges = [
      { name: "1-2", min: 1, max: 2 },
      { name: "3-4", min: 3, max: 4 },
      { name: "5+", min: 5, max: Infinity },
    ];
    const familySizeData = familySizeRanges.map((range) => {
      const count = mockContacts.filter(
        (c) => c.familySize >= range.min && c.familySize <= range.max
      ).length;
      return {
        name: range.name,
        value: count,
        percentage: (count / totalContacts) * 100,
      };
    });

    // Purchase recency
    const purchaseRecencyData = purchaseRecencyRanges.map((range) => {
      const count = mockContacts.filter(
        (c) =>
          c.lastPurchaseYear >= range.min && c.lastPurchaseYear <= range.max
      ).length;
      return {
        name: range.name,
        value: count,
        percentage: (count / totalContacts) * 100,
      };
    });

    // Purchase intent
    const withIntent = mockContacts.filter((c) => c.nextPurchaseIntent).length;

    // Average satisfaction
    const avgSatisfaction = (
      mockContacts.reduce((acc, c) => acc + c.satisfactionScore, 0) /
      totalContacts
    ).toFixed(1);

    // AI-like insights: Top segments
    const highIncomeWithIntent = mockContacts.filter(
      (c) => c.incomeBracket === "High" && c.nextPurchaseIntent && c.consent
    ).length;
    const familyOrientedSUV = mockContacts.filter(
      (c) =>
        c.familySize >= 4 &&
        c.interests.includes("family") &&
        c.vehicleType === "SUV"
    ).length;
    const ecoFriendlyYoung = mockContacts.filter(
      (c) => c.age <= 35 && c.interests.includes("eco-friendly") && c.consent
    ).length;

    // Correlation example: Brand popularity by gender
    const brandByGender = mockContacts.reduce((acc, c) => {
      if (!acc[c.vehicleBrand]) acc[c.vehicleBrand] = { Male: 0, Female: 0 };
      acc[c.vehicleBrand][c.gender]++;
      return acc;
    }, {});

    // Purchase year trend
    const purchaseYears = mockContacts.reduce((acc, c) => {
      acc[c.lastPurchaseYear] = (acc[c.lastPurchaseYear] || 0) + 1;
      return acc;
    }, {});
    const purchaseYearData = Object.entries(purchaseYears)
      .map(([year, count]) => ({ year: parseInt(year), count }))
      .sort((a, b) => a.year - b.year);

    return {
      totalContacts,
      withConsent: (withConsent / totalContacts) * 100,
      withoutConsent: (withoutConsent / totalContacts) * 100,
      vehicleTypes,
      locations,
      ageData,
      genderData,
      emailAvailable: (emailAvailable / totalContacts) * 100,
      phoneAvailable: (phoneAvailable / totalContacts) * 100,
      topLocations,
      vehicleTypeData,
      incomeData,
      brandData,
      interestData,
      familySizeData,
      purchaseRecencyData,
      withIntent: (withIntent / totalContacts) * 100,
      avgSatisfaction,
      highIncomeWithIntent,
      familyOrientedSUV,
      ecoFriendlyYoung,
      brandByGender,
      purchaseYearData,
    };
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const StatCard = ({ icon, title, value, subtitle, color = "primary" }) => (
    <Card
      sx={{
        height: "100%",
        background: `linear-gradient(135deg, ${theme.palette[color].light} 0%, ${theme.palette[color].main} 100%)`,
        color: "white",
      }}
    >
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <Avatar
            sx={{ bgcolor: "white", mr: 2, color: theme.palette[color].main }}
          >
            {icon}
          </Avatar>
          <Typography variant="h6" component="div">
            {title}
          </Typography>
        </Box>
        <Typography variant="h4" component="div" gutterBottom>
          {value}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.9 }}>
          {subtitle}
        </Typography>
      </CardContent>
    </Card>
  );

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <Paper
          sx={{
            p: 2,
            background: alpha(theme.palette.background.default, 0.9),
          }}
        >
          <Typography variant="body2" fontWeight="bold">
            {label}
          </Typography>
          {payload.map((entry, index) => (
            <Typography key={index} variant="body2" color={entry.color}>
              {entry.name}: {entry.value}
              {entry.payload.percentage &&
                ` (${entry.payload.percentage.toFixed(1)}%)`}
            </Typography>
          ))}
        </Paper>
      );
    }
    return null;
  };

  return (
    <Box
      sx={{
        p: isMobile ? 1 : 3,
        background: theme.palette.background.default,
        minHeight: "100vh",
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{ mb: 3, color: theme.palette.text.primary }}
      >
        AI-Powered Marketing Contacts Analysis
      </Typography>

      {/* Overview Cards with added stats */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            icon={<People />}
            title="Total Contacts"
            value={analytics.totalContacts}
            subtitle="Vehicle owners in database"
            color="primary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            icon={<CheckCircle />}
            title="With Consent"
            value={`${Math.round(analytics.withConsent)}%`}
            subtitle="Ready for direct marketing"
            color="success"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            icon={<Phone />}
            title="Phone Available"
            value={`${Math.round(analytics.phoneAvailable)}%`}
            subtitle="Contacts with phone numbers"
            color="secondary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            icon={<TrendingUp />}
            title="Purchase Intent"
            value={`${Math.round(analytics.withIntent)}%`}
            subtitle="Likely to buy soon"
            color="info"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            icon={<Email />}
            title="Email Available"
            value={`${Math.round(analytics.emailAvailable)}%`}
            subtitle="Email campaign ready"
            color="info"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            icon={<CheckCircle />}
            title="Avg Satisfaction"
            value={analytics.avgSatisfaction}
            subtitle="Out of 10 - Loyalty indicator"
            color="warning"
          />
        </Grid>
      </Grid>

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        sx={{
          mb: 3,
          "& .MuiTab-root": { fontWeight: "bold" },
          "& .Mui-selected": { color: theme.palette.primary.main },
        }}
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Demographics" />
        <Tab label="Vehicle Analysis" />
        <Tab label="Geographic Data" />
        <Tab label="Behavioral Insights" />
        <Tab label="AI Targeting Recommendations" />
      </Tabs>

      {tabValue === 0 && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Cake sx={{ mr: 1 }} /> Age Distribution
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <AreaChart data={analytics.ageData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Area
                      type="monotone"
                      dataKey="value"
                      stroke={theme.palette.primary.main}
                      fill={theme.palette.primary.light}
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Male sx={{ mr: 1 }} /> <Female sx={{ mr: 1 }} /> Gender
                  Distribution
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={Object.entries(analytics.genderData).map(
                        ([name, value]) => ({ name, value })
                      )}
                      cx="50%"
                      cy="50%"
                      labelLine={false}
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                      label={({ name, percent }) =>
                        `${name}: ${(percent * 100).toFixed(0)}%`
                      }
                    >
                      {Object.entries(analytics.genderData).map(
                        (entry, index) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                          />
                        )
                      )}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <AttachMoney sx={{ mr: 1 }} /> Income Bracket Distribution
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={analytics.incomeData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="value" fill={theme.palette.success.main} />
                  </BarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <FamilyRestroom sx={{ mr: 1 }} /> Family Size Distribution
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={analytics.familySizeData}
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                      label={({ name, percent }) =>
                        `${name}: ${(percent * 100).toFixed(0)}%`
                      }
                    >
                      {analytics.familySizeData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {tabValue === 1 && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <DirectionsCar sx={{ mr: 1 }} /> Vehicle Types
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={analytics.vehicleTypeData} layout="vertical">
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" />
                    <YAxis type="category" dataKey="name" width={80} />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="value" fill={theme.palette.secondary.main} />
                  </BarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <TrendingUp sx={{ mr: 1 }} /> Vehicle Brand Popularity
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={analytics.brandData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="name"
                      angle={-45}
                      textAnchor="end"
                      height={60}
                    />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="value" fill={theme.palette.warning.main} />
                  </BarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <CalendarToday sx={{ mr: 1 }} /> Purchase Recency
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={analytics.purchaseRecencyData}
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                      label={({ name, percent }) =>
                        `${name}: ${(percent * 100).toFixed(0)}%`
                      }
                    >
                      {analytics.purchaseRecencyData.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <TrendingUp sx={{ mr: 1 }} /> Purchases Over Years
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <LineChart data={analytics.purchaseYearData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="year" />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Line
                      type="monotone"
                      dataKey="count"
                      stroke={theme.palette.error.main}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {tabValue === 2 && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <LocationOn sx={{ mr: 1 }} /> Top Locations
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart data={analytics.topLocations}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="name"
                      angle={-45}
                      textAnchor="end"
                      height={60}
                    />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Bar dataKey="value" fill={theme.palette.info.main} />
                  </BarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <LocationOn sx={{ mr: 1 }} /> Location Distribution
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <PieChart>
                    <Pie
                      data={analytics.topLocations}
                      cx="50%"
                      cy="50%"
                      outerRadius={80}
                      fill="#8884d8"
                      dataKey="value"
                      label={({ name, percent }) =>
                        `${name}: ${(percent * 100).toFixed(0)}%`
                      }
                    >
                      {analytics.topLocations.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={COLORS[index % COLORS.length]}
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {tabValue === 3 && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Interests sx={{ mr: 1 }} /> Top Interests
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <RadarChart
                    cx="50%"
                    cy="50%"
                    outerRadius="80%"
                    data={analytics.interestData}
                  >
                    <PolarGrid />
                    <PolarAngleAxis dataKey="name" />
                    <PolarRadiusAxis />
                    <Radar
                      name="Count"
                      dataKey="value"
                      stroke={theme.palette.secondary.main}
                      fill={theme.palette.secondary.light}
                      fillOpacity={0.6}
                    />
                    <Tooltip />
                  </RadarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <CheckCircle sx={{ mr: 1, color: "success.main" }} />
                  Behavioral Segments
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Lightbulb color="success" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Next Purchase Intent"
                      secondary={`${Math.round(
                        analytics.withIntent
                      )}% show interest in buying soon`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircle color="success" />
                    </ListItemIcon>
                    <ListItemText
                      primary="High Satisfaction"
                      secondary={`Average score: ${analytics.avgSatisfaction}/10 - Potential for upsell`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Interests color="success" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Interest-Based Targeting"
                      secondary="Tailor campaigns to top interests like eco-friendly and adventure"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}

      {tabValue === 4 && (
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Lightbulb sx={{ mr: 1, color: "primary.main" }} />
                  AI-Generated Targeting Recommendations
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <CheckCircle color="success" />
                    </ListItemIcon>
                    <ListItemText
                      primary="High-Income Buyers with Intent"
                      secondary={`${analytics.highIncomeWithIntent} contacts: Focus luxury vehicle emails on this group for high conversion.`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <FamilyRestroom color="info" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Family-Oriented SUV Owners"
                      secondary={`${analytics.familyOrientedSUV} contacts: Promote spacious, safe SUVs to large families in urban areas.`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Cake color="warning" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Young Eco-Friendly Enthusiasts"
                      secondary={`${analytics.ecoFriendlyYoung} contacts: Target 18-35 age group with electric/hybrid offers via social media.`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Warning color="error" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Low Satisfaction Segments"
                      secondary="Identify and re-engage contacts with scores <7 to improve loyalty and gather feedback."
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card sx={{ mb: 3 }}>
              <CardContent>
                <Typography
                  variant="h6"
                  gutterBottom
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <Warning sx={{ mr: 1, color: "warning.main" }} /> Limitations
                  & Challenges
                </Typography>
                <List>
                  <ListItem>
                    <ListItemIcon>
                      <Cancel color="error" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Missing Consent"
                      secondary={`${Math.round(
                        analytics.withoutConsent
                      )}% require opt-in before campaigns`}
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Warning color="warning" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Geographic Spread"
                      secondary="Customize regional offers for dispersed locations to boost relevance"
                    />
                  </ListItem>
                  <ListItem>
                    <ListItemIcon>
                      <Phone color="warning" />
                    </ListItemIcon>
                    <ListItemText
                      primary="Incomplete Contact Info"
                      secondary="Supplement phone/email gaps with alternative channels like social targeting"
                    />
                  </ListItem>
                </List>
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" gutterBottom>
                  Advanced Insights: Brand Preference by Gender
                </Typography>
                <ResponsiveContainer width="100%" height={300}>
                  <BarChart
                    data={Object.entries(analytics.brandByGender).map(
                      ([brand, genders]) => ({
                        name: brand,
                        Male: genders.Male || 0,
                        Female: genders.Female || 0,
                      })
                    )}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="name"
                      angle={-45}
                      textAnchor="end"
                      height={60}
                    />
                    <YAxis />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend />
                    <Bar dataKey="Male" fill={COLORS[0]} />
                    <Bar dataKey="Female" fill={COLORS[1]} />
                  </BarChart>
                </ResponsiveContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </Box>
  );
};

export default MarketingContactsAnalysis1;
